// @ts-nocheck
import React from 'react';
import css from '../shared/css';
import { LogoIcon, MenuToggleIcon } from '../icons';

interface Props {
  toggleNav: (event: React.MouseEvent<HTMLSpanElement>) => void;
  closed?: boolean;
}

export default ({ closed, toggleNav }: Props) => {
  const halfWidth = {
    width: 90,
  };
  const slideLogo = {
    width: '32px',
    overflow: 'hidden',
  };
  const menuIconSlide = {
    right: 14,
  };
  const flipIcon = {
    display: 'block',
    transform: 'scaleX(-1)',
  };

  return (
    <div style={closed ? halfWidth : null} className={styles.container}>
      <a href="/">
        <LogoIcon
          style={closed ? slideLogo : null}
          className={styles.logo}
          height={28}
          width={108}
          color="#41403b"
        />
      </a>
      <span
        style={closed ? menuIconSlide : null}
        className={styles.icon}
        onClick={toggleNav}
        role="menu-toggle"
      >
        <MenuToggleIcon key="0" className={styles.menuIcon} style={closed ? flipIcon : null} width="18" />
      </span>
    </div>
  );
};

const styles = css({
  container: {
    borderBottom: '1px solid #eee',
    height: 48,
    width: 225,
    display: 'flex',
    overflow: 'hidden',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    background: '#fff',
    position: 'absolute',
    zIndex: 100,
    transition: 'all 0.1s ease-in-out',
  },
  icon: {
    position: 'absolute',
    cursor: 'pointer',
    marginTop: 0,
    padding: '12px 8px',
    zIndex: 2,
    right: 10,
    top: 2,
  },
  menuIcon: {
    verticalAlign: 'middle',
    fill: '#bbb',
  },
  logo: {
    left: 10,
    top: 9,
    position: 'absolute',
    zIndex: 2,
    display: 'block',
    fill: 'inherit',
    ':hover': {
      opacity: 0.9,
      transform: 'scale(1.03)',
      transition: 'all .3s ease-in-out 0s',
    },
  },
});
